var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7CB6E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wzqxs5axpa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10a7.51 7.51 0 0 0-7.5 7.5c0 5.384 6.988 12.128 7.284 12.413a.31.31 0 0 0 .432 0c.296-.285 7.284-7.029 7.284-12.413A7.51 7.51 0 0 0 20 10zm0 10.938a3.438 3.438 0 1 1 0-6.876 3.438 3.438 0 0 1 0 6.876z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wzqxs5axpa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0bff821230c270e9cfd92cf42dc8cc2d.svg";
export { ForwardRef as ReactComponent };